import { render } from "./EditVertical.vue?vue&type=template&id=16f05beb"
import script from "./EditVertical.vue?vue&type=script&lang=js"
export * from "./EditVertical.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__